import { FC } from 'react';
import { ChassisType } from '../../../@types/ChassisType';
import ChassisOption from '../ChassisOption/ChassisOption';
import { Stack } from '@mui/material';
import { E4 as E4_2025 } from '../../../data/products/Carts/ESeriesProducts/E4/E4Chassis-2025';
import { E4Assy as E4Assy2025 } from '../../../data/products/Carts/ESeriesProducts/E4/E4Chassis-2025';

interface ESeriesChassisOptionsProps {
  preassembled: boolean;
  retailConfigurator: boolean;
  handleTabChange: (event: any, tab: string, chassisType?: ChassisType) => void;
  hideAllPrices: boolean,
}

const ESeriesChassisOptions: FC<ESeriesChassisOptionsProps> = ({ preassembled, retailConfigurator, handleTabChange, hideAllPrices }) => {
  const chassisOptions: ChassisType[] =
    retailConfigurator
      ? [E4Assy2025]
      : preassembled
        ? [E4Assy2025]
        : [E4_2025];
  return (
    <Stack
      width="100%"
      direction="row"
      alignItems="center"
      justifyContent="center"
      useFlexGap
      flexWrap="wrap"
      spacing={6}>
      {chassisOptions.map((chassisType, index) => (
        <a
          style={{ cursor: 'pointer', zIndex: 1 }}
          key={index}
          onClick={() =>
            handleTabChange(undefined, '/cart-builder', chassisType)}>
          <ChassisOption
            chassisOption={chassisType}
            retailConfigurator={retailConfigurator}
            showPrice={!hideAllPrices} />
        </a>
      ))}
    </Stack>
  );
}

export default ESeriesChassisOptions;
